const AGE_LABELS: Record<string, string> = {
  "14-22": "14–22 yrs",
  "23-34": "23–34 yrs",
  "35-44": "35–44 yrs",
  "45-54": "45–54 yrs",
  "55-65": "55–65 yrs",
  "65+": "65+ yrs",
};

const INCOME_LABELS: Record<string, string> = {
  Premium: "Premium",
  "Medium+": "Medium+",
  MassMarket: "Mass market",
};

const FAMILY_LABELS: Record<string, string> = {
  Single: "Single",
  "Married/Co-viewing": "Married / Co-viewing",
  Unknown: "Unknown",
};

const MARITAL_LABELS: Record<string, string> = {
  Married: "Married",
  Divorced: "Divorced",
  Single: "Single",
  Unknown: "Unknown",
};

const MEDIA_LABELS: Record<string, string> = {
  Hard_Cord_Cutter: "Hard cord-cutter",
  Light_Cord_Cutter: "Light cord-cutter",
  Linear_TV_Addict: "Linear TV addict",
  Hybrid_Streamer: "Hybrid streamer",
  Sports_Live_Only: "Sports / live only",
};

const KIDS_LABELS: Record<string, string> = {
  None: "No kids",
  "Infants_0-2": "Infants (0–2)",
  "Preschoolers_3-5": "Preschoolers (3–5)",
  "SchoolKids_6-12": "School kids (6–12)",
  Teens: "Teens",
};

const INTENT_LABELS: Record<string, string> = {
  Foodies: "Foodies",
  SportsFans: "Sports fans",
  HealthIntenders: "Health intenders",
  Automotive: "Automotive",
};

const GENDER_LABELS: Record<string, string> = {
  Male: "Male",
  Female: "Female",
  Unknown: "Unknown",
};

const humanizeFreeform = (value: string): string => {
  if (!value) return "";
  return value
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^./, (c) => c.toUpperCase());
};

export type ClassificationProperty =
  | "gender"
  | "ageGroup"
  | "incomeTier"
  | "familyStatus"
  | "maritalStatus"
  | "mediaConsumptionType"
  | "kidsDemographics"
  | "mandatoryIntent"
  | "interest";

export const labelForProperty = (
  property: ClassificationProperty | string,
  value: string | null | undefined,
): string => {
  if (!value) return "—";
  switch (property) {
    case "gender":
      return GENDER_LABELS[value] ?? value;
    case "ageGroup":
      return AGE_LABELS[value] ?? value;
    case "incomeTier":
      return INCOME_LABELS[value] ?? value;
    case "familyStatus":
      return FAMILY_LABELS[value] ?? humanizeFreeform(value);
    case "maritalStatus":
      return MARITAL_LABELS[value] ?? value;
    case "mediaConsumptionType":
      return MEDIA_LABELS[value] ?? humanizeFreeform(value);
    case "kidsDemographics":
      return KIDS_LABELS[value] ?? humanizeFreeform(value);
    case "mandatoryIntent":
      return INTENT_LABELS[value] ?? humanizeFreeform(value);
    case "interest":
      return humanizeFreeform(value);
    default:
      return value;
  }
};

const SOURCE_LABELS: Record<string, string> = {
  ai: "AI",
  manual: "Manual",
  fact: "Fact",
  lookalike: "Look-alike",
};

export const labelForSource = (source: string): string =>
  SOURCE_LABELS[source] ?? humanizeFreeform(source);
